import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_BLUE_1, TSS_BLUE_2, TSS_DARK_BLUE } from 'tss-core-lib-common';

var styles = void 0;

var PlusMinusSelect = function PlusMinusSelect(_ref) {
  var disabled = _ref.disabled,
      positive = _ref.positive,
      onChange = _ref.onChange;
  return React.createElement(
    'div',
    { className: css(styles.container, disabled && styles.disabled), role: 'button', tabIndex: 0, onClick: disabled ? null : function () {
        return onChange(!positive);
      } },
    React.createElement(
      'span',
      { className: css(styles.plus, !positive && styles.disabledSign) },
      '+'
    ),
    React.createElement(
      'span',
      { className: css(styles.slash) },
      '/'
    ),
    React.createElement(
      'span',
      { className: css(styles.minus, positive && styles.disabledSign) },
      '\u2013'
    )
  );
};

PlusMinusSelect.propTypes = {
  disabled: PropTypes.bool,
  positive: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

PlusMinusSelect.defaultProps = {
  disabled: false,
  positive: true
};

styles = StyleSheet.create({
  container: {
    width: '4rem',
    height: '3.6rem',
    fontSize: '1.6rem',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid ' + TSS_BLUE_1(),

    ':hover': {
      backgroundColor: TSS_BLUE_1()
    }
  },

  disabled: {
    backgroundColor: TSS_BLUE_2(),
    color: TSS_DARK_BLUE(0.5),
    cursor: 'not-allowed'
  },

  disabledSign: {
    opacity: 0.2
  },

  plus: {
    position: 'relative',
    top: -3
  },

  minus: {
    position: 'relative',
    bottom: -2
  },

  slash: {
    position: 'realtive',
    opacity: 0.6
  }
});

export default PlusMinusSelect;